import StatsContainer from './StatsContainer'

export default StatsContainer
